
import { nGetCsrf,nRefreshAccessToken } from './Csrf.js';
import { xmREQ_Work,xmREP_Work,xmRED_Work } from './Req.js';

export async function nLike(isLike, id) {
  await nGetCsrf();

  try {
    let rep;
    if (isLike) {
      rep = await xmRED_Work(`/users/favorites/${id}`);
    } else {
      rep = await xmREP_Work(`/users/favorites/${id}`);
    }

    localStorage.setItem('uuid', nGetUuid());
    return rep;
  } catch (err) {
    if(err.status!==404) { throw err; } else { return null; }
  }
}

export async function nAccessCheck() {
  const v =await nRefreshAccessToken();
  return v;
}

export async function nOption(types = '') {
  const query = types ? `?types=${types}` : '';
  const url = `/options${query}`;
  try {
    const rep = await xmREQ_Work(url);
    if (!rep || !rep.options) return { options: {} };
    return rep;
  } catch (err) {
    if (err?.status === 404) return { options: {} };
    throw err;
  }
}

export function isEmail(email) {
  const emailRule = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
  return emailRule.test(email);
}

export async function nGetUserProfile() {
  if(!localStorage.getItem('auth')||localStorage.getItem('auth')==0) {
    return;
  }
  try {
    const rep = await xmREQ_Work('/users');
    return rep;
  } catch (err) {
    throw err;
  }
}

export function nGetUuid() {

  const vGuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0, v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });

  return vGuid;

}

export function nRemoveAuth() {
  localStorage.setItem('uuid', nGetUuid());
  localStorage.setItem('auth', 0);
  localStorage.removeItem('auth');
}